import { render, staticRenderFns } from "./account-audit.vue?vue&type=template&id=4253b2e2&scoped=true&"
import script from "./account-audit.vue?vue&type=script&lang=js&"
export * from "./account-audit.vue?vue&type=script&lang=js&"
import style0 from "./account-audit.vue?vue&type=style&index=0&id=4253b2e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4253b2e2",
  null
  
)

export default component.exports